import { TourDisplayRecord } from './tourTracker';

const STORAGE_KEY_PREFIX = 'tour_display_count_';

export const getLocalStorageTourDisplayCount = (tourId: string): TourDisplayRecord | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${tourId}`);
    if (!stored) {
      return null;
    }
    return JSON.parse(stored) as TourDisplayRecord;
  } catch (error) {
    console.warn(`Failed to parse tour display count for ${tourId}:`, error);
    return null;
  }
};

export const recordLocalStorageTourDisplay = (
  tourId: string,
  overrides?: Partial<TourDisplayRecord>,
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const existing = getLocalStorageTourDisplayCount(tourId);
    const newRecord: TourDisplayRecord = {
      count: overrides?.count !== undefined ? overrides.count : (existing?.count || 0) + 1,
      lastShown: overrides?.lastShown || new Date().toISOString(),
      ...overrides,
    };

    localStorage.setItem(`${STORAGE_KEY_PREFIX}${tourId}`, JSON.stringify(newRecord));
  } catch (error) {
    console.warn(`[Tour] Failed to record display for ${tourId}:`, error);
  }
};

export const resetLocalStorageTourDisplay = (tourId: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    localStorage.removeItem(`${STORAGE_KEY_PREFIX}${tourId}`);
  } catch (error) {
    console.warn(`[Tour] Failed to reset display for ${tourId}:`, error);
  }
};
